var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-play-container"},[_c('video',{attrs:{"controls":"","src":'./video/' + _vm.videoname}}),_c('div',{class:_vm.isMolile ? 'mobile-back-icon-box' : 'back-icon-box',on:{"click":_vm.backPage}},[_c('img',{staticClass:"back-icon",attrs:{"src":_vm.backIcon}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }